import * as tslib_1 from "tslib";
import { EventEmitter, OnInit } from '@angular/core';
import { DagSourceModel } from "@app/workflow-common/services/DagSourceModel";
import { FormBuilder, FormControl, Validators } from "@angular/forms";
import { ConditionlDelayBlockModel } from "@app/workflow-common/services/models/ConditionlDelayBlockModel";
var ConditionalDelayBlockWidgetComponent = /** @class */ (function () {
    function ConditionalDelayBlockWidgetComponent(formBuilder) {
        this.formBuilder = formBuilder;
        this.isConditional = false;
        this.conditionalColName = '';
        this.close = new EventEmitter();
        this.blockName = 'conditionalDelayBlock';
        this.isFormSubmitted = false;
        this.conditionalDelayBlockData = {};
        this.showDeleteBtn = false;
        this.isReadOnlyMode = false;
        this.inputModel = undefined;
        this.units = ['Minutes', 'Hours', 'Days', 'Months'];
        this.minutesInterval = Array.from(Array(60).keys());
        this.hoursInterval = Array.from(Array(24).keys());
        this.daysInterval = Array.from(Array(31).keys());
        this.monthsInterval = Array.from(Array(13).keys());
    }
    ConditionalDelayBlockWidgetComponent.prototype.ngOnInit = function () {
        this.conditionalDelayBlockData = this.dagSourceModel.getBlocksSource().getBlockByKey(this.blockObject.key);
        this.fields = Object.values(this.dagSourceModel.getFieldMetadata()).filter(function (item) { return item['type'] === 'date'; });
        var blockObject = tslib_1.__assign({}, this.blockObject);
        var modelData = blockObject['model'] ? blockObject['model'] : undefined;
        if (modelData) {
            this.showDeleteBtn = true;
        }
        this.inputModel = new ConditionlDelayBlockModel(modelData);
        var formGroupConfig = {
            interval: new FormControl(this.inputModel.interval, [Validators.required, function (control) {
                    var forbidden = control.value == 0;
                    return forbidden ? { notAllowed: { value: control.value } } : null;
                }]),
            type: new FormControl(this.inputModel.type),
            unit: new FormControl(this.inputModel.unit, [Validators.required]),
            event_method: new FormControl(this.inputModel.event_method, [Validators.required]),
            col_name: new FormControl(this.inputModel.col_name, [Validators.required]),
            fieldLabel: new FormControl(this.inputModel.fieldLabel, [Validators.required]),
        };
        if (this.isConditional) {
            formGroupConfig['condition'] = this.formBuilder.group({});
        }
        this.form = this.formBuilder.group(formGroupConfig);
    };
    ConditionalDelayBlockWidgetComponent.prototype.onChangeUnit = function (event) {
        if ((this.form.get('unit').value == 'Months' && this.form.get('interval').value > 12)
            || (this.form.get('unit').value == 'Days' && this.form.get('interval').value > 30)
            || (this.form.get('unit').value == 'Hours' && this.form.get('interval').value > 23)) {
            this.form.get('interval').setValue(0);
        }
    };
    ConditionalDelayBlockWidgetComponent.prototype.onChangeField = function (event) {
        var currentField = this.fields.find(function (field) { return field['col_name'] == event; });
        if (currentField) {
            this.form.get('fieldLabel').setValue(currentField['text']);
        }
    };
    ConditionalDelayBlockWidgetComponent.prototype.save = function () {
        this.isFormSubmitted = true;
        var blockObject = tslib_1.__assign({}, this.blockObject);
        blockObject.model = new ConditionlDelayBlockModel(this.form.value);
        var condition = this.form.value.condition;
        if (this.isConditional) {
            blockObject['condition'] = condition;
            blockObject['isConditional'] = true;
        }
        console.log('xzxc', blockObject);
        this.close.emit({
            action: 'save_and_close',
            data: blockObject
        });
    };
    ConditionalDelayBlockWidgetComponent.prototype.closeModal = function () {
        this.close.emit({
            action: 'close',
            data: null
        });
    };
    ConditionalDelayBlockWidgetComponent.prototype.remove = function () {
        var blockObject = tslib_1.__assign({}, this.blockObject);
        blockObject.model = this.inputModel;
        this.close.emit({
            action: 'remove_block',
            data: blockObject
        });
    };
    return ConditionalDelayBlockWidgetComponent;
}());
export { ConditionalDelayBlockWidgetComponent };
